import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'pratiu';

  constructor(private router: Router, private metaService: Meta) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this.setCanonicalTag();
      }
    });

    this.setCanonicalTag();
  }

  private setCanonicalTag() {
    const currentUrl = window.location.href;
    this.metaService.updateTag({
      name: 'canonical',
      content: currentUrl
    });
  }
}
